import RsaAccettazione from "../";

const routes = [
    {
        name: "RsaAccettazioneListPage",
        path: "/rsaaccettazione",
        component: RsaAccettazione.RsaAccettazioneListPage,
        meta: { title: " Accettazione" },
    },
    {
        name: "RsaAccettazioneEdit",
        path: "/rsaaccettazione/edit/:id",
        component: RsaAccettazione.RsaAccettazioneEdit,
        meta: { title: " Accettazione" },
    },
    {
        name: "RsaAccettazioneViewPage",
        path: "/rsaaccettazione/view/:id",
        component: RsaAccettazione.RsaAccettazioneViewPage,
        meta: { title: " Accettazione" },
    },
    { name: "RsaAccettazioneRicetteEdit", path: "/rsaaccettazione/ricette/edit/:id", component: RsaAccettazione.RsaAccettazioneRicetteEditPage, meta: { title: " Accettazione Ricette" } },
    {
        name: "RsaStoricoPostoLettoListPage",
        path: "/rsastoricopostoletto",
        component: RsaAccettazione.RsaStoricoPostoLettoListPage,
        meta: { title: " Storico Posti Letto" },
    },
    {
        name: "RsaStoricoPostoLettoViewPage",
        path: "/rsastoricopostoletto/view/:id",
        component: RsaAccettazione.RsaStoricoPostoLettoViewPage,
        meta: { title: " Storico Posto Letto" },
    },
];

export default routes;
